module.exports = {"140623100":"新城镇","140623101":"右卫镇","140623102":"威远镇","140623103":"元堡子镇","140623200":"牛心堡乡","140623202":"高家堡乡","140623204":"杨千河乡","140623205":"李达窑乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140623.json
// module id = 405
// module chunks = 0